import { Injectable, signal } from '@angular/core';

// Used to expose an offset that is used by some components(QB/full sheet overlay)
// to set the bottom padding/margins, so that the content doesn't get covered

// REMARK: currently set only by QuickBet. In case other scenarios are added please rename the class/methods accordingly
@Injectable({ providedIn: 'root' })
export class BottomOffsetService {
    private readonly defaultOffset = 0;
    readonly bottomOffset = signal<number>(this.defaultOffset);

    setBottomOffset(bottomOffset: number): void {
        this.bottomOffset.set(bottomOffset);
    }

    resetBottomOffset(): void {
        this.bottomOffset.set(this.defaultOffset);
    }
}
